import { Controller } from "@hotwired/stimulus"

// Conditionally shows/hides document upload sections based on yes/no question answers
// This is used when a question's "yes" answer requires supporting documentation to be uploaded
//
// Usage:
//   data-controller="tax-organizer--conditional-upload"
//   data-tax-organizer--conditional-upload-trigger-name-value="questions[123][answer]"
//   data-tax-organizer--conditional-upload-target-id-value="document_upload_id"
//
export default class extends Controller {
  static values = {
    triggerName: String,  // Name attribute of the radio button group that triggers show/hide
    targetId: String      // ID of the upload div to show/hide
  }

  connect() {
    this.updateVisibility()
    this.addRadioListeners()
  }

  disconnect() {
    this.removeRadioListeners()
  }

  addRadioListeners() {
    this.getRadioButtons().forEach(radio => {
      radio.addEventListener('change', this.handleRadioChange)
    })
  }

  removeRadioListeners() {
    this.getRadioButtons().forEach(radio => {
      radio.removeEventListener('change', this.handleRadioChange)
    })
  }

  handleRadioChange = () => {
    this.updateVisibility()
  }

  updateVisibility() {
    const uploadDiv = this.getUploadDiv()
    if (!uploadDiv) return

    const checkedRadio = this.getCheckedRadio()
    const fileInput = uploadDiv.querySelector('input[type="file"]')

    if (checkedRadio && checkedRadio.value === 'yes') {
      // Show upload div when "yes" is selected
      uploadDiv.style.display = 'block'

      // Only make it required if no files have been uploaded yet
      if (fileInput) {
        const hasExistingFiles = uploadDiv.querySelector('.fa-check-circle') !== null
        if (!hasExistingFiles) {
          fileInput.setAttribute('required', 'required')
        } else {
          fileInput.removeAttribute('required')
        }
      }
    } else {
      // Hide upload div when "no" is selected or nothing is selected
      uploadDiv.style.display = 'none'
      if (fileInput) {
        fileInput.removeAttribute('required')
      }
    }
  }

  getRadioButtons() {
    return document.querySelectorAll(`input[name="${this.triggerNameValue}"]`)
  }

  getCheckedRadio() {
    return Array.from(this.getRadioButtons()).find(r => r.checked)
  }

  getUploadDiv() {
    return document.getElementById(this.targetIdValue)
  }
}
